import {
  IFilterHandler,
  FilterOptions,
  ConfigureOptionsParams,
  FilterPassParams,
  InclusiveExclusiveFilterModel,
  GridFilterUnionModel,
  AppliedFilterItem
} from '../../filter-types';
import { FilterResultFacade } from '../../filter-result-facade';
import {
  CalendarFilter,
  CalendarFiltersState
} from '../../../../state/calendar-filter/state';
import {
  calculateIsInclusive,
  calculateStoreValues,
  excludeValues
} from '../../filter-utils';
import { FilterType } from '../../../../grid/utils/filter/filter.utils';
import {
  FilterChange,
  FilterClear
} from '../../../../state/calendar-filter/actions';

export abstract class FilterHandlerBase implements IFilterHandler {
  get name(): string {
    return 'default';
  }

  get label(): string {
    return null;
  }

  get isInclusiveExclusive(): boolean {
    return false;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    throw new Error('Not implemented');
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    // empty stub
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    throw new Error('Advanced filter has been processed as grid filter');
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    return false;
  }

  getAppliedFiltersItems(filter: CalendarFilter): AppliedFilterItem[] {
    return [];
  }
  filterClear(
    filterChange: FilterClear,
    state: CalendarFiltersState
  ): FilterChange {
    return { name: this.name, value: undefined };
  }

  toStoreFilterModel(
    model: GridFilterUnionModel,
    filterOptions: FilterOptions
  ): GridFilterUnionModel {
    if (
      this.isInclusiveExclusive &&
      !!model['filterType'] &&
      model['filterType'] === FilterType.Set
    ) {
      const filterModel: InclusiveExclusiveFilterModel = model as InclusiveExclusiveFilterModel;
      const filterValues: string[] = filterModel.values
        ? filterModel.values
        : [];
      const options: string[] = this.getFilterOptions(filterOptions);
      const isInclusive: boolean = calculateIsInclusive(filterValues, options);
      const storeValues: string[] = calculateStoreValues(
        filterValues,
        options,
        isInclusive
      );

      return {
        ...filterModel,
        isInclusive,
        storeValues
      };
    }
    return model;
  }

  toGridFilterModel(
    filter: CalendarFilter,
    filterOptions: FilterOptions
  ): GridFilterUnionModel {
    return filter.model;
  }

  recalculateExclusiveValues(
    currentFilter: CalendarFilter,
    filterOptions: FilterOptions
  ) {
    if (this.isInclusiveExclusive) {
      const filterModel = currentFilter.model as InclusiveExclusiveFilterModel;
      const options: string[] = this.getFilterOptions(filterOptions);

      if (filterModel.isInclusive) {
        filterModel.values = filterModel.storeValues
          ? filterModel.storeValues
          : [];
      } else {
        filterModel.values = excludeValues(options, filterModel.storeValues);
      }
    }
  }
}
